import React from 'react';
import { Collapse } from 'antd';
import { Link } from 'react-router-dom';
import styles from './CompetitionSystemsDescription.module.css';

const { Panel } = Collapse;

const matchTableRows = [
    [4, '6\n3', '4\n2', '-', '-', '-', '-'],
    [5, '10\n4', '5\n2', '-', '-', '-', '-'],
    [6, '15\n5', '6\n2', '10\n3', '9\n2', '10\n4', 2],
    [7, '21\n6', '7\n2', '12\n3', '11\n2', '13\n4', 2],
    [8, '28\n7', '8\n3', '14\n4', '13\n3', '16\n5', 2],
    [9, '36\n8', '9\n3', '16\n4', '15\n3', '15\n4', 3],
    [10, '45\n9', '10\n3', '18\n4', '17\n3', '18\n4', 3],
    [11, '55\n10', '11\n3', '20\n4', '19\n3', '21\n4', 3],
    [12, '66\n11', '12\n3', '22\n4', '21\n3', '20\n5', 4],
    [13, '78\n12', '13\n3', '24\n4', '23\n3', '23\n5', 4],
    [14, '91\n13', '14\n3', '26\n5', '25\n4', '26\n5', 4],
    [15, '105\n14', '15\n3', '28\n5', '27\n4', '29\n5', 4],
    [16, '120\n15', '16\n4', '30\n5', '29\n4', '32\n6', 4],
];

const panelHeader = (icon, title) => (
    <span className={styles.panelHeader}>
        <span className={styles.panelIcon}>{icon}</span>{title}
    </span>
);

const CompetitionSystemsDescription = () => {
    return (
        <div className={styles.container}>
            <h1>Systemy rozgrywek w turniejach BTT</h1>

            <Collapse accordion bordered={false} className={styles.accordion}>
                <Panel header={panelHeader('🔄', 'Każdy z każdym')} key="1">
                    <div className={styles.panelBody}>
                        <p>
                            Każdy uczestnik gra z każdym. Kolejność meczów wyznacza metoda
                            Bergera (parowanie rywali w systemie kołowym).
                        </p>
                        <p>Klasyfikacja w tabeli:</p>
                        <ul>
                            <li>liczba wygranych setów,</li>
                            <li>
                                różnica gemów wygranych i przegranych — punkty super-tiebreaka
                                trzeciego seta przeliczane są proporcjonalnie do liczby gemów
                                w secie (np. przy secie do 4 gemów 10 pkt tiebreaka liczone jest
                                jako 4 pkt),
                            </li>
                            <li>
                                przy równej liczbie punktów i takiej samej różnicy gemów
                                decyduje bezpośredni mecz między zawodnikami.
                            </li>
                        </ul>
                    </div>
                </Panel>

                <Panel header={panelHeader('🏆', 'System pucharowy')} key="2">
                    <div className={styles.panelBody}>
                        <p>
                            Przegrany odpada po każdej porażce, turniej trwa do ostatniego
                            zwycięzcy. W BTT obowiązuje zasada rozegrania min. 2 meczów, dlatego
                            system stosowany jest głównie jako faza finałowa systemu „Faza
                            grupowa + finałowa".
                        </p>
                    </div>
                </Panel>

                <Panel header={panelHeader('🇧🇷', 'Brazylijski do dwóch przegranych')} key="3">
                    <div className={styles.panelBody}>
                        <p>
                            Podobny do systemu pucharowego, ale pierwsza porażka nie eliminuje —
                            gracz dostaje drugą szansę w drabince przegranych i może wygrać cały
                            turniej. Druga porażka kończy udział w zawodach.
                        </p>
                    </div>
                </Panel>

                <Panel header={panelHeader('⚡', 'Brazylijski szybki')} key="4">
                    <div className={styles.panelBody}>
                        <p>
                            Przyspieszony wariant systemu brazylijskiego do turniejów
                            jednodniowych. Topologia drabinki bez zmian (dwie przegrane = koniec
                            udziału), z dwiema modyfikacjami:
                        </p>
                        <ul>
                            <li>
                                <strong>Bez powtórki pojedynku</strong> — jeśli ci sami
                                zawodnicy mieliby zagrać ze sobą po raz drugi, mecz się nie
                                odbywa; awansuje zwycięzca pierwszego spotkania (etykieta
                                „bez gry", ELO nie jest naliczane).
                            </li>
                            <li>
                                <strong>Format meczu</strong> — w zależności od liczby
                                graczy format pro-set lub best-of-3.
                            </li>
                        </ul>
                    </div>
                </Panel>

                <Panel header={panelHeader('👥', 'Faza grupowa + finałowa')} key="5">
                    <div className={styles.panelBody}>
                        <p>
                            Turniej zaczyna się fazą grupową — uczestnicy grają w grupach każdy
                            z każdym. Dwóch najlepszych z każdej grupy awansuje do fazy
                            finałowej rozgrywanej systemem pucharowym.
                        </p>
                    </div>
                </Panel>

                <Panel header={panelHeader('🏅', 'Liga grupowa')} key="6">
                    <div className={styles.panelBody}>
                        <p>
                            Długoterminowe rozgrywki ligowe z podziałem na grupy (A, B, C…)
                            według poziomu gry. W każdej rundzie zawodnicy w grupie grają każdy
                            z każdym, z punktacją 3-2-1-0. Po rundzie najlepsi awansują do
                            wyższej grupy, a najsłabsi spadają do niższej. Ranking ogólny sumuje
                            wkłady ze wszystkich rund; możliwe jest też zamrożenie udziału na
                            jedną rundę.
                        </p>
                        <Link to="/liga-info" className={styles.leagueLink}>
                            Pełny opis ligi →
                        </Link>
                    </div>
                </Panel>

                <Panel header={panelHeader('📊', 'Liczba meczów w turnieju')} key="7">
                    <div className={styles.panelBody}>
                        <p className={styles.tableIntro}>
                            Poniższa tabela prezentuje liczbę meczów do rozegrania w turnieju
                            jednodniowym dla wybranego systemu. Druga liczba wskazuje minimalną
                            liczbę meczów, którą zawodnik musi zagrać, aby osiągnąć mecz
                            finałowy.
                        </p>
                        <div className={styles.tableWrapper}>
                            <table className={styles.systemsTable}>
                                <thead>
                                <tr>
                                    <th>Liczba<br/>graczy</th>
                                    <th>Każdy z<br/>każdym</th>
                                    <th>Pucharowy</th>
                                    <th>Brazylijski</th>
                                    <th>Brazylijski<br/>szybki</th>
                                    <th>Grupa+<br/>finał</th>
                                    <th>Liczba<br/>grup</th>
                                </tr>
                                </thead>
                                <tbody>
                                {matchTableRows.map((row, idx) => (
                                    <tr key={idx}>
                                        {row.map((cell, i) => (
                                            <td key={i}>
                                                {typeof cell === 'string'
                                                    ? cell.split('\n').map((line, index) => (
                                                        <div key={index}>{line}</div>
                                                    ))
                                                    : cell}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                        <p className={styles.tableNote}>
                            <strong>Legenda:</strong><br/>
                            Pierwsza liczba – łączna liczba meczów<br/>
                            Druga liczba – najkrótsza droga do finału
                        </p>
                    </div>
                </Panel>
            </Collapse>
        </div>
    );
};

export default CompetitionSystemsDescription;
